import axios from "axios";

const adminApi = process.env.REACT_APP_ADMIN_API_CONFIG;

export const getReferrals = async (data) => {
    console.log('adminApi', adminApi);
    let path = `/referral`;
    if (data) {
        path = path + `?referred_user_id=${data.referred_user_id}&referral_first_name=${data.referral_first_name}&referral_last_name=${data.referral_last_name}`
    } else {
        const companyUuid = JSON.parse(localStorage.getItem('userDetails')).company_uuid;
        path = path + `?company_uuid=${companyUuid}`
    }
    try {
        const response = await axios.get(adminApi + path);
        return response
    } catch (error) {
        return "Unable to fetch referrals";
    }
};

export const postReferrals = async (referralData) => {
    const path = '/referral';
    const data = referralData
    try {
        const response = await axios.post(adminApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to upload referrals';
    }
}

export const updateReferral = async (data) => {
    try {
        console.log("data", data)
        const path = "/referral";
        const response = await axios.put(adminApi + path, data);
        return {
            data: response,
        };
    } catch (error) {
        return 'Unable to update referral';
    }
}

export const updateReferralStatus = async (data) => {
    try {
        console.log("data", data)
        const path = "/referral/status";
        const response = await axios.put(adminApi + path, data);
        return {
            data: response,
        };
    } catch (error) {
        return 'Unable to update referral';
    }
}

export const getDocumentsPriority = async () => {
    console.log('adminApi', adminApi);
    let path = `/documents/priority`;
    const companyUuid = JSON.parse(localStorage.getItem('userDetails')).company_uuid;
    path = path + `?company_uuid=${companyUuid}`
    try {
        const response = await axios.get(adminApi + path);
        return response
    } catch (error) {
        return "Unable to fetch documents priority";
    }
};

export const updateDocumentPriority = async (data) => {
    console.log('adminApi', adminApi);
    let path = `/documents/priority`;
    // const companyUuid = JSON.parse(localStorage.getItem('userDetails')).company_uuid;
    // path = path + `?company_uuid=${companyUuid}`
    try {
        const response = await axios.put(adminApi + path, data);
        return response
    } catch (error) {
        return "Unable to fetch documents priority";
    }
};

export const getRequests = async (data) => {
    let path = `/documets/new`;
    path = path + `?company_uuid=${data}`
    try {
        const response = await axios.get(adminApi + path);
        console.log("dataaa:",response)
        return response
    } catch (error) {
        return "Unable to fetch referrals";
    }
};

export const updateRequests = async (data) => {
    try {
        console.log("data", data)
        const path = "/documets/new";
        const response = await axios.put(adminApi + path, data);
        return {
            data: response,
        };
    } catch (error) {
        return 'Unable to update document status';
    }
}

export const sendRequestDocuments = async (data) => {
    console.log('adminApi', adminApi);
    let path = `/documets/new`;

    const companyUuid = localStorage.getItem('selectedCompanyUuid') 
        ? localStorage.getItem('selectedCompanyUuid') 
        : JSON.parse(localStorage.getItem('userDetails')).company_uuid;

    const companyName = localStorage.getItem('companyName');
    const requestData = {
        ...data,
        company_uuid: companyUuid,
        company_name: companyName
    };

    try {
        const response = await axios.post(adminApi + path, requestData);
        return response;
    } catch (error) {
        console.error('Error sending document request:', error);
        return "Unable to fetch documents priority";
    }
};
